// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiPeerToPeer {
    static getAttributeTypeMap() {
        return MedicalBiPeerToPeer.attributeTypeMap;
    }
}
MedicalBiPeerToPeer.discriminator = undefined;
MedicalBiPeerToPeer.additionalProperties = false;
MedicalBiPeerToPeer.attributeTypeMap = [
    {
        "name": "available",
        "baseName": "available",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "submissionDeadline",
        "baseName": "submissionDeadline",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiPeerToPeer.js.map